import React from 'react';

type TenantSignupLayoutProps = {
  title: string;
  subtitle?: string;
  step?: number;
  totalSteps?: number;
  children: React.ReactNode;
};

const TenantSignupLayout: React.FC<TenantSignupLayoutProps> = ({
  title,
  subtitle,
  step,
  totalSteps,
  children,
}) => {
  const showProgress = typeof step === 'number' && typeof totalSteps === 'number';

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#261136',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 16px',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 720,
          backgroundColor: '#FFFFFF',
          borderRadius: 12,
          padding: 32,
          boxShadow: '0 12px 30px rgba(0, 0, 0, 0.25)',
        }}
      >
        {/* Header */}
        <div style={{ marginBottom: 24 }}>
          {showProgress && (
            <div
              style={{
                fontSize: 12,
                textTransform: 'uppercase',
                letterSpacing: 1,
                color: '#7B1FA2',
                marginBottom: 4,
              }}
            >
              Step {step} of {totalSteps}
            </div>
          )}
          <h1
            style={{
              margin: 0,
              marginBottom: subtitle ? 4 : 12,
              fontSize: 24,
              color: '#261136',
            }}
          >
            {title}
          </h1>
          {subtitle && (
            <p
              style={{
                margin: 0,
                fontSize: 14,
                color: '#555',
              }}
            >
              {subtitle}
            </p>
          )}
        </div>

        {/* Light progress bar */}
        {showProgress && (
          <div
            style={{
              height: 6,
              borderRadius: 999,
              backgroundColor: '#eee',
              marginBottom: 24,
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                height: '100%',
                width: `${Math.min(100, (step! / totalSteps!) * 100)}%`,
                background:
                  'linear-gradient(90deg, #7B1FA2 0%, #B388FF 100%)',
                transition: 'width 0.3s ease',
              }}
            />
          </div>
        )}

        {/* Page content */}
        {children}
      </div>
    </div>
  );
};

export default TenantSignupLayout;
